<app-section #parentSection
             [key]="key"
             [formConfig]="formConfig"
             [sectionRef]="section"
             [formGroup]="formGroup"
             *ngIf="sectionVisible"
             class="agreements-section"
             [ngClass]="{'agreements-section--old': !isNext}"
             [title]="title">

    <ng-template #section>

        <div *ngIf="checkboxesGroupConfig"
             class="agreements-section__editable-agreements">
            <app-checkboxes-group [config]="checkboxesGroupConfig"
                                  [fieldKeys]="checkboxesGroupFieldKeys"
                                  [bean]="bean"
                                  [formConfig]="formConfig"
                                  [formGroup]="formGroup"
                                  [formFactoryService]="formFactoryService"
                                  (checkAllChange)="onCheckAllAgreementsChange($event)"
                                  (checkboxChange)="onFieldChange($event)"
                                  (checkboxInteractiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
            >
            </app-checkboxes-group>
        </div>

        <div class="agreements-section__required-field-info">
            {{ agreementsRequiredSymbol }} {{ 'SHARED.requiredField' | translate }}
        </div>

        <div class="agreements-section__readonly-agreements">
            <div *ngFor="let agreement of readonlyAgreements"
                 class="agreements-section__readonly-agreement"
                 [innerHTML]="agreementsService.getAgreementValue(agreement).value | safeHtml"
            ></div>
        </div>

    </ng-template>

</app-section>
